export default __webpack_public_path__ + "static/media/colorectal_plot_male.9f48b432.png";